import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { deployedAt, formatDeployedAt } from '../../lib/deployed-at.js';

/** Pastille du cabinet, à gauche de son nom dans le pied de barre. */
export function CabinetTile() {
  return (
    <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-muted">
      <Building2 className="h-4 w-4 text-muted-foreground" />
    </div>
  );
}

/**
 * Nom du cabinet. Au-dessus, en texte secondaire, la date et l'heure de la dernière image servie.
 * L'instant vient de la construction : sans `VITE_DEPLOYED_AT`, la ligne n'existe pas.
 */
export function CabinetLabel({ name, hint }: { name: string; hint?: string }) {
  const { t, i18n } = useTranslation();
  const built = deployedAt();
  const when = built === null ? null : formatDeployedAt(built, i18n.language);

  return (
    <div className="flex min-w-0 flex-1 flex-col items-start gap-0.5">
      {built !== null && when !== null && (
        <time
          dateTime={built.toISOString()}
          className="w-full truncate text-xs leading-tight text-muted-foreground"
          title={t('shell:sidebar.deployed_at', { when })}
          data-testid="text-sidebar-deployed-at"
        >
          {when}
        </time>
      )}
      <span
        className="w-full min-w-0 truncate text-left text-sm font-medium"
        data-testid="text-sidebar-cabinet-name"
      >
        {name}
      </span>
      {hint && <span className="w-full truncate text-xs text-muted-foreground">{hint}</span>}
    </div>
  );
}
